/*
* Event Issuance Criteria Fields
*
*/
import {labelValueArrayToObject} from "../../util";

export const AccreditationEventIssuanceCriteriaFields = (args = {}) => {

  //console.log(TangibleFields)
  const scheduledTypesArgs = args.scheduledTypesArgs;
  const pointTypes = args.pointTypes;
  const fieldDefs = args.accreditationFields;

  let professions = labelValueArrayToObject( window.tgblCredProfessions );

  const isCertPluginActivated = !!args.value.tgbl_cred_agency_is_cert_plugin_activated;

  return [

    // Event type
    {
      type: 'combo-box',
      name: 'content_type',
      label: 'Content',
      choices: args.choices
    },

    {
      type: 'combo-box',
      name: 'content_id',
      label: 'Content Name',
      isAsync: true,
      ajaxAction: 'tgbl_content_type_items',
      dependent: true,
      asyncArgs: {
        content_type: '{{content_type}}'
      }
    },

    {
      type: 'combo-box',
      name: 'earning_event',
      label: 'Event',
      isAsync: true,
      ajaxAction: 'tgbl_content_type_events',
      dependent: true,
      asyncArgs: {
        content_type: '{{content_type}}'
      }
    },

    {
      type: 'combo-box',
      name: 'eligible_professions',
      label: 'Eligible Professions',
      multiple: true,
      choices: professions
    },

    {
      type: 'fieldInstances',
      name: 'agency_fields',
      fieldDefs,
    },

    // Certificate fields
    {
      type: isCertPluginActivated ? 'combo-box' : 'hidden',
      name: 'event_certificate_template',
      label: 'Certificate Template',
      description: 'The default PHP certificate template for this accreditation.',
      isAsync: true,
      ajaxAction: 'tgbl_content_type_items',
      asyncArgs: {
        content_type: 'tgbl-certificate'
      }
    },
    {
      type: isCertPluginActivated ? 'repeater' : 'hidden',
      name: 'event_certificate_template_custom_fields',
      layout: 'block',
      repeatable: false,
      //maxlength: 3,
      //value: '[{"custom_field_name":"asdsadsa","custom_field_value":"qOOOOOqe"},{"key":"603f736c5e6560","custom_field_name":"BBBBB","custom_field_value":"CCCCC"}]',
      //value: args.certCustomFieldsRepeaterValue,
      description: 'These fields can be edited in the Certificate Builder.',
      sectionTitle: 'Certificate Fields - TODO make this field update/re-render on the Certificate Template field change.',
      fields: [
        { type: 'text',
          name: 'custom_field_name',
          label: 'Field Name'
        },
        { type: 'text',
          name: 'custom_field_value',
          label: 'Value'
        },
      ],
      wrapper : {
        class: 'certificate-custom-fields-repeater'
      }
    },

    // Training codes repeater
    {
      type: 'issuanceTrainingCodes',
      name: 'training_codes',
      scheduledTypesArgs,
    },

    // Earned Points
    {
      type: 'issuanceEarnedPoints',
      name: 'earned_points',
      pointTypes
    },

  ]
}
